module.exports = global.WebSocket || global.MozWebSocket;



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/transport/browser/websocket.js
// module id = 16
// module chunks = 0